import { useTranslation } from "react-i18next";

import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import header_logo from "./images/2esim_maintain_logo.png";
import styles from "./style.2esim.module.scss";
const InMaintenance = () => {
  const { t } = useTranslation();
  const [maintenanceInfo, setMaintenanceInfo] = useState({
    start_time: "",
    end_time: "",
  });

  //get info of maintenance by any api
  const getMaintainInfo = () => {
    axios
      .get(`${process.env.REACT_APP_API_MAIN_URL}/api/phone/support/brand`, {
        params: {},
      })
      .then((res) => {
        console.log(res);
        if (res.status === 200) window.location.href = "/";
        return undefined;
      })
      .catch((error) => {
        console.log(error.response);
        setMaintenanceInfo(error.response.data.data);
        return error.response;
      })
      .finally(() => {});
  };

  useEffect(() => {
    getMaintainInfo();
  }, []);

  return (
    <div className={styles.inMaintenance}>
      <img
        src={header_logo}
        className={styles.headerLogo}
        // preview={false}
        alt="2esim-header"
      />
      <div className={styles.mobileLogoContainer}>
        <img
          src={header_logo}
          className={styles.mobileHeaderLogo}
          // preview={false}
          alt="2esim-header"
        />
      </div>
      <div className={styles.wrapper}>
        <div className={styles.title}>{t("normal.web.inMaintenance")}</div>

        <div className={styles.timeBox}>
          <div className={styles.subtitle}>{t("maintenance.2esim.time")}</div>
          <div className={styles.time}>
            {dayjs(maintenanceInfo?.start_time).format("YYYY-MM-DD HH:mm")}
            <br />
            {t("normal.until")}
            <br />
            {dayjs(maintenanceInfo?.end_time).format("YYYY-MM-DD HH:mm")}
          </div>
        </div>
        <div className={styles.desc}>
          {t("maintenance.desc")}， <br />
          {t("maintenance. 2esim.desc")}
        </div>
      </div>
      <div className={styles.patent}>{t("normal.2esim.patent")}</div>
    </div>
  );
};

export default InMaintenance;
